import { dateFormatMap } from '@op/constants';
import { formatTime } from '../../render-helper';

export default function steamRealtimeNewlyAddedColumns(params: any) {
  const { date_type } = params;
  return [
    {
      renderHelper: [formatTime(dateFormatMap[date_type])],
      header: 'Date',
      render: 'time',
    },
    {
      header: 'Positive',
      render: 'select_recommend',
    },
    {
      header: 'Negative',
      render: 'select_non_recommend',
    },
    {
      renderHelper: [formatTime(dateFormatMap[date_type])],
      header: 'This time period',
      render: 'old_time',
    },
    {
      header: 'Positive The previous corresponding period',
      render: 'old_select_recommend',
    },
    {
      header: `Negative The previous corresponding period`,
      render: 'old_select_non_recommend',
    },
  ];
}
